import { render, staticRenderFns } from "./tracking-container.vue?vue&type=template&id=4520c1a3&scoped=true&lang=pug"
import script from "./tracking-container.js?vue&type=script&lang=js&external"
export * from "./tracking-container.js?vue&type=script&lang=js&external"
import style0 from "./tracking-container.vue?vue&type=style&index=0&id=4520c1a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4520c1a3",
  null
  
)

export default component.exports